import {
  ErrorResponse,
  InvisibleCodeResponse,
  LineCodeRequest,
  LineCodeResponse,
  VisitorRegistrationRequest,
  VisitorRegistrationResponse,
} from '../types';
import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';

// 방문객 등록 API
export const createVisitor = async (data: VisitorRegistrationRequest): Promise<VisitorRegistrationResponse> => {
  try {
    console.log('Creating visitor with URL:', apiClient.defaults.baseURL + API_ENDPOINTS.VISITOR.CREATE);
    console.log('Request data:', data);

    const response = await apiClient.post<VisitorRegistrationResponse>(API_ENDPOINTS.VISITOR.CREATE, data);
    return response.data;
  } catch (error: any) {
    console.error('Create visitor error:', error);
    throw error as ErrorResponse;
  }
};

// 인비저블 코드 조회 API
export const getInvisibleCode = async (confirmCode: string): Promise<InvisibleCodeResponse> => {
  try {
    console.log(
      'Getting invisible code with URL:',
      apiClient.defaults.baseURL + API_ENDPOINTS.VISITOR.GET_INVISIBLE(confirmCode),
    );

    const response = await apiClient.get<InvisibleCodeResponse>(API_ENDPOINTS.VISITOR.GET_INVISIBLE(confirmCode));
    return response.data;
  } catch (error: any) {
    console.error('Get invisible code error:', error);
    throw error as ErrorResponse;
  }
};

// Line 코드 조회 API
export const getLineCodeInfo = async (confirmCode: string): Promise<LineCodeResponse> => {
  try {
    const response = await apiClient.get<LineCodeResponse>(API_ENDPOINTS.INFO.LINE(confirmCode));
    return response.data;
  } catch (error: any) {
    throw error as ErrorResponse;
  }
};
